<shared-special-instructions [value]="specialInstructions$ | async" directive-menu-flow-page [pageIdentifier]="-100"
    [isExpanded]="isExpanded" [isExpanded]="(specialInstructions$ | async) ? true : false"
    (onChange)="handleChange($event)" (onToggle)="handleToggle($event)">
</shared-special-instructions>